import { prop } from 'js/utils/ramda.util';
import { useMemo, useCallback } from 'react';
import { useUserSelector } from 'js/store/hooks';

import * as helpers from '../helpers';

export const useNumberFormatter = () => {
    const userLocale = useUserSelector(prop('lang'));

    const formatNumber = useCallback((number, options, locale) =>
        helpers.formatNumber(number, options, locale || userLocale), [userLocale]);

    return useMemo(() => ({
        formatNumber,
        delocalizeNumber: helpers.delocalizeNumber
    }), [formatNumber]);
};

